import { render, staticRenderFns } from "./AulaSwitchButton.vue?vue&type=template&id=20d92b55&scoped=true&"
import script from "./AulaSwitchButton.vue?vue&type=script&lang=js&"
export * from "./AulaSwitchButton.vue?vue&type=script&lang=js&"
import style0 from "./AulaSwitchButton.vue?vue&type=style&index=0&id=20d92b55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d92b55",
  null
  
)

export default component.exports